import React from "react";

import Form from "@Components/Form";
import { URLS, NON_WORKING_DAY_WEEKEND_URL } from "configs/constants";

const initialValues = {
  day: "",
  state: [],
  type_of_attendance_absent: "",
  type_of_attendance_present: "",
  is_global: false,
};

const WeekendViewDetails = () => {
  const formFields = [
    {
      type: "renderonly",
      name: "day",
      key: "day",
      label: "Day",
    },
    {
      type: "renderonly",
      name: "type_of_attendance_absent_name",
      key: "type_of_attendance_absent_name",
      label: "Type of Attendance (Absent)",
    },
    {
      type: "renderonly",
      name: "type_of_attendance_present_name",
      key: "type_of_attendance_present_name",
      label: "Type of Attendance (Present)",
    },
    {
      type: "renderonly",
      name: "is_global",
      label: "Global",
      key: "is_global",
      valueType: "boolean",
      noValue: "No",
      yesValue: "Yes",
    },
    {
      type: "renderonly",
      name: "states",
      key: "states",
      isMulti: true,
      label: "State",
      requiredValidation: "is_global",
      renderKey: "is_global",
      renderValue: false,
    },
  ];

  const formButtons = ["cancel"];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={NON_WORKING_DAY_WEEKEND_URL}
      listRoute={URLS.NON_WORKING_DAY_WEEKEND}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Weekend View Details"
    />
  );
};

export default WeekendViewDetails;
